// extracted by mini-css-extract-plugin
export default {"nav":"Navigation_nav__7WdPp","link":"Navigation_link__13qe6","active":"Navigation_active__1vK5v"};